import _ from 'lodash'
import moment from 'moment'
import 'moment-duration-format'
import quertString from 'query-string'
import { ZIPPO_URL } from '../config'

export function join (array) {
  if (_.compact(array).length) {
    return _.compact(array).reduce(function (s, i) { return s + ', ' + i })
  }
}

export function getDuration (duration) {
  let formatted = moment.duration(parseInt(duration, 10), 'seconds').format('hh:mm:ss')

  if (formatted.length === 5) {
    formatted = '00:' + formatted
  }
  if (formatted.length === 2) {
    formatted = '00:00:' + formatted
  }
  return formatted
}

export function formatDateTime (momentObj) {
  return momentObj.format('DD MMM YYYY hh:mm A')
}

export function getAccessTokenFromUrl () {
  const query = quertString.parse(window.location.search)
  window.history.replaceState({}, document.title, '/')
  return query.accessToken
}

export function getAccessToken () {
  const accessToken = getAccessTokenFromUrl()
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken)
  }
  return localStorage.getItem('accessToken')
}

export function frameTheatreAddress (theatre) {
  let address = []

  if (!_.isEmpty(theatre.city)) {
    address.push(theatre.city.name)
  }

  if (!_.isEmpty(theatre.province)) {
    address.push(theatre.province.name)
  }

  if (!_.isEmpty(theatre.country)) {
    address.push(theatre.country.name)
  }

  return address.join(', ')
}

export function downloadKdm (fileName, data) {
  const form = document.createElement('form')
  const node = document.createElement('input')
  node.type = 'hidden'
  form.action = `${ZIPPO_URL}/?filename=${fileName}.zip`
  form.method = 'POST'
  data.forEach(item => {
    node.name = item.filename
    node.value = item.url
    form.appendChild(node.cloneNode())
  })
  form.style.display = 'none'
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}



// WEBPACK FOOTER //
// ./src/app/common/util/helper.js